import "./css/style.css";

export default function QuorvexLoader() {
    return (
        <div className={"quorvex-loader-container my-4"}>
            <img
                id={"quorvexLoader"}
                src={"https://assets.nextrades.ai/assets/qvmarkets/loader.gif"}
                alt={"quorvexLoader"}
            />
            {/* <svg id="quorvexLoader" width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M41.6682 13.7667L32.2321 4.32702C27.1314 -0.775672 18.8623 -0.775672 13.7616 4.32702L4.32555 13.7667C-0.775183 18.8694 -0.775183 27.1416 4.32555 32.2443L13.7616 41.684C16.1959 44.1192 19.358 45.3933 22.5514 45.5V40.868C22.1687 36.5373 20.3242 32.3071 17.0115 28.9932C13.6612 25.6478 9.38864 23.7963 5.01569 23.4323V22.5787C9.38864 22.2209 13.6675 20.3694 17.0115 17.0178C20.3618 13.6663 22.2126 9.38577 22.5702 5.00486H23.4235C23.7811 9.38577 25.6319 13.6663 28.9822 17.0178C32.3325 20.3694 36.6114 22.2209 40.9906 22.5787V23.4323C36.6114 23.79 32.3325 25.6416 28.9822 28.9932C25.6319 32.3447 23.7874 36.6189 23.4235 40.9936V45.5C26.6232 45.3996 29.7916 44.1255 32.2384 41.684L41.6745 32.2443C46.7752 27.1416 46.7752 18.8694 41.6745 13.7667H41.6682Z" fill="#001453"/>
            </svg> */}
        </div>
    );
}
